import React, { useRef, useContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import colors from './constants/colors';
import constants from './constants/constants';
import { useQuery, gql, useMutation } from '@apollo/client';
import { GetUserContext } from './localStorage/Store';
import Cookies from 'universal-cookie';
import styl from './styl';
var dateFormat = require('dateformat');
//Use this:
// import {React, useRef, useContext,useEffect, useState, styled, colors, constants, useQuery, gql, dateFormat, useMutation, GetUserContext, Cookies, styl } from "../imports";

export {React,
    useRef,
    useEffect,
    useContext,
    useState,
    styled,
    colors,
    constants,
    useQuery,
    gql,
    useMutation,
    GetUserContext,
    Cookies,
    styl,
    dateFormat};




